<template>
  <div class="item-block item-vinculado-inner">
    <label class="item-label item-vinculado-label">
      <span class="item-index item-index-cond">
        <i class="fas fa-code-branch"></i>
      </span>
      {{ item.titulo }}<span v-if="!!item.obrigatorio" class="required-star">*</span>
    </label>

    <input
      v-if="item.tipo_pergunta == 2"
      type="text"
      class="form-control input-modern"
      placeholder="Digite sua resposta"
      v-model="item.resposta"
      :disabled="expirado"
    />

    <input
      v-if="item.tipo_pergunta == 3"
      type="number"
      step="any"
      class="form-control input-modern"
      placeholder="0"
      v-model="item.resposta"
      :disabled="expirado"
    />

    <div v-if="item.tipo_pergunta == 1 && item.multipla_escolha" class="multipla-escolha-wrapper">
      <div
        v-for="resp in (item.itens || [])"
        :key="resp.resposta_checklist_id"
        class="multipla-opcao"
      >
        <label class="multipla-label">
          <input
            type="checkbox"
            :value="resp.resposta_checklist_id"
            v-model="item.resposta"
            :disabled="expirado"
          />
          <span class="opcao-texto">{{ resp.titulo }}</span>
        </label>
        <div
          v-if="resp.item_vinculado && Array.isArray(item.resposta) && item.resposta.includes(resp.resposta_checklist_id)"
          class="item-vinculado-block"
        >
          <item-execucao :item="resp.item_vinculado" :expirado="expirado" />
        </div>
      </div>
    </div>

    <template v-if="item.tipo_pergunta == 1 && !item.multipla_escolha">
      <select
        class="form-control input-modern"
        :value="item.resposta"
        :disabled="expirado"
        @change="onRespostaChange($event)"
      >
        <option value="">Selecione uma opção</option>
        <option
          v-for="resp in (item.itens || [])"
          :key="resp.resposta_checklist_id"
          :value="resp.resposta_checklist_id"
        >{{ resp.titulo }}</option>
      </select>
      <div v-if="item._linkedItem" class="item-vinculado-block">
        <item-execucao :item="item._linkedItem" :expirado="expirado" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ItemExecucao",
  // Self-referencing component
  beforeCreate() {
    this.$options.components.ItemExecucao = this.$options;
  },
  props: {
    item: { type: Object, required: true },
    expirado: { type: Boolean, default: false },
  },
  created() {
    if (this.item.resposta === undefined || this.item.resposta === null) {
      this.$set(this.item, "resposta", this.item.multipla_escolha ? [] : "");
    }
    if (this.item._linkedItem === undefined) {
      this.$set(this.item, "_linkedItem", null);
    }
  },
  methods: {
    onRespostaChange(event) {
      const raw = event.target.value;
      const val = raw === '' ? '' : (isNaN(Number(raw)) ? raw : Number(raw));
      this.$set(this.item, 'resposta', val);
      const itens = this.item.itens || [];
      const resp = itens.find(r => String(r.resposta_checklist_id) === String(val));
      const linked = (resp && resp.item_vinculado) ? resp.item_vinculado : null;
      if (linked && linked.resposta === undefined) {
        this.$set(linked, 'resposta', linked.multipla_escolha ? [] : '');
      }
      this.$set(this.item, '_linkedItem', linked);
    },
  },
};
</script>

<style scoped>
.item-index-cond {
  background: transparent !important;
  color: #a78bfa !important;
  width: 34px;
  height: 34px;
  font-size: 15px;
  flex-shrink: 0;
}

.item-vinculado-label {
  font-size: 1.05rem !important;
  font-weight: 600;
  gap: 10px;
  margin-top: 8px;
  margin-bottom: 16px;
}

.multipla-escolha-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.multipla-opcao {
  display: flex;
  flex-direction: column;
}

.multipla-label {
  display: flex;
  align-items: center;
  padding: 11px 16px;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  font-size: 1rem;
  font-weight: normal;
  margin-bottom: 0;
}

.multipla-label:hover {
  background: rgba(0, 123, 255, 0.07);
}

.multipla-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
}

.opcao-texto {
  margin-left: 14px;
}
</style>
